;(function(){

    'use strict';


    init();

    function init(){
        var instrumentationKey = sessionStorage.instrumentationKey;
        var appInsights = initializeAppInsights(instrumentationKey);

        var dummyDsn = '//me@localhost:1234/dev';
        var raven = initializeRaven(dummyDsn);
        forwardRavenCapturesIntoAppInsights(raven, appInsights);

        captureNavigatorDataWithRaven(raven);


    }


    function captureNavigatorDataWithRaven(raven){
        var payload = {
            host: document.location.host
        };

        for(var x in window.navigator)
            payload[x] = window.navigator[x];

        raven.captureMessage('window.navigator',{
            messageData: payload
        });
    }

    function initializeRaven(dsn){

        return Raven.config(dsn
            , {
                logger: 'javascript',
                whitelistUrls:['localhost'],
                ignoreErrors: [
                    // Random plugins/extensions
                    'top.GLOBALS',
                    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error. html
                    'originalCreateNotification',
                    'canvas.contentDocument',
                    'MyApp_RemoveAllHighlights',
                    'http://tt.epicplay.com',
                    'Can\'t find variable: ZiteReader',
                    'jigsaw is not defined',
                    'ComboSearch is not defined',
                    'http://loading.retry.widdit.com/',
                    'atomicFindClose',
                    // Facebook borked
                    'fb_xd_fragment',
                    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
                    // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
                    'bmi_SafeAddOnload',
                    'EBCallBackMessageReceived',
                    // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
                    'conduitPage'
                ],
                ignoreUrls: [
                    // Facebook flakiness
                    /graph\.facebook\.com/i,
                    // Facebook blocked
                    /connect\.facebook\.net\/en_US\/all\.js/i,
                    // Woopra flakiness
                    /eatdifferent\.com\.woopra-ns\.com/i,
                    /static\.woopra\.com\/js\/woopra\.js/i,
                    // Chrome extensions
                    /extensions\//i,
                    /^chrome:\/\//i,
                    // Other plugins
                    /127\.0\.0\.1:4001\/isrunning/i,  // Cacaoweb
                    /webappstoolbarba\.texthelp\.com\//i,
                    /metrics\.itunes\.apple\.com\.edgesuite\.net\//i
                    //,/localhost/i
                ]
            }).install();
    }

    function forwardRavenCapturesIntoAppInsights(raven, appInsights){

        var handledAt ='UI Raven';
        var properties = {
            "Logger": "javascript",
            "UI-type": "info|error",
            "UI-context":"some description"
        };



        raven._makeRequest= function(opts) {

            var props = null;

            if(opts.data.exception) {
                props = angular.copy(properties);
                props['UI-type'] = 'error';
                props['UI-context'] = 'Global exception handler';
                var lastException = raven.lastException();
                window.appInsights.trackException(lastException, handledAt, props);
            }

            if(opts.data.messageData) {
                props = angular.copy(properties);
                props['UI-type'] = 'info';
                props['UI-context'] = 'Wrapper-UI Handshake';

                var msgBuilder = [];
                msgBuilder.push(opts.data.message);
                msgBuilder.push(angular.toJson(opts.data.messageData,2));
                window.appInsights.trackTrace(msgBuilder.join('\n'),props);
            }

            // app insights js lib does not return a success or error value
            if (opts.onSuccess)
                opts.onSuccess();

        }

    }


    function initializeAppInsights(instrumentationKey){
        var appInsights=window.appInsights||function(config){
                function r(config){t[config]=function(){var i=arguments;t.queue.push(function(){t[config].apply(t,i)})}}var t={config:config},u=document,e=window,o="script",s=u.createElement(o),i,f;for(s.src=config.url||"//az416426.vo.msecnd.net/scripts/a/ai.0.js",u.getElementsByTagName(o)[0].parentNode.appendChild(s),t.cookie=u.cookie,t.queue=[],i=["Event","Exception","Metric","PageView","Trace"];i.length;)r("track"+i.pop());return r("setAuthenticatedUserContext"),r("clearAuthenticatedUserContext"),config.disableExceptionTracking||(i="onerror",r("_"+i),f=e[i],e[i]=function(config,r,u,e,o){var s=f&&f(config,r,u,e,o);return s!==!0&&t["_"+i](config,r,u,e,o),s}),t
            }({
                instrumentationKey:instrumentationKey
                , disableExceptionTracking : true
                , disableAjaxTracking: true
                , diagnosticLogInterval: 5
                , maxBatchInterval: 5

            });

        // Track every SPA initialization
        appInsights.trackPageView();



        window.appInsights=appInsights;
        return appInsights;
    }

})();